﻿import { Controller } from "@hotwired/stimulus";

function createInputElement(name, value) {
    var input = document.createElement("input");

    input.setAttribute("type", "hidden");
    input.setAttribute("id", name);
    input.setAttribute("name", name);
    input.setAttribute("value", value);

    return input;
}

export default class extends Controller {
    static get values() {
        return {
            message: String
        };
    }

    connect() {
        var tagName = this.element.tagName;
        if (tagName === "A") {
            this.element.addEventListener("click", e => this.handleLinkConfirmation(e));
        }
        else if (tagName === "BUTTON") {
            this.element.addEventListener("click", e => this.handleButtonConfirmation(e));
        }
    }

    handleLinkConfirmation(e) {
        e.preventDefault();
        bootbox.confirm(this.messageValue, function (confirmed) {
            if (confirmed) {
                window.location.href = e.target.href;
            }
        });
    }

    handleButtonConfirmation(e) {
        e.preventDefault();

        bootbox.confirm(this.messageValue, function (confirmed) {
            if (confirmed) {
                var element = e.target;

                var form = element.closest("form");
                var name = element.getAttribute("name");
                
                if (name) {
                    var value = element.getAttribute("value");
                    if (value) {
                        var existing = form.querySelector(`input[name="${name}"]`);
                        if (!existing) {
                            var input = createInputElement(name, value);
                            form.append(input);
                        }
                        else {
                            existing.value = value;
                        }
                    }
                }

                form.submit();
            }
        });
    }
}
